module.exports = __webpack_public_path__ + "static/media/3.1f52ea53.jpg";